import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { IMaskInput } from 'react-imask';
import api from '../services/api';

// Função de validação de CPF
const isValidCPF = (cpf) => {
  cpf = cpf.replace(/[^\d]+/g, '');
  if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) return false;

  let soma = 0;
  for (let i = 0; i < 9; i++) soma += parseInt(cpf.charAt(i)) * (10 - i);
  let resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf.charAt(9))) return false;

  soma = 0;
  for (let i = 0; i < 10; i++) soma += parseInt(cpf.charAt(i)) * (11 - i);
  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  return resto === parseInt(cpf.charAt(10));
};

export default function LoginPage() {
  const navigate = useNavigate();

  const [cpf, setCpf] = useState('');
  const [dataNascimento, setDataNascimento] = useState('');
  const [message, setMessage] = useState('');
  const [mensagemCadastro, setMensagemCadastro] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [loadingCadastro, setLoadingCadastro] = useState(false);

  const [cadastro, setCadastro] = useState({
    first_name: '',
    last_name: '',
    email: '',
    cpf: '',
    telefone: '',
    date_of_birth: '',
    nome_social: '',
  });

  const handleLogin = async (e) => {
    e.preventDefault();
    setMessage('');

    const cpfLimpo = cpf.replace(/[^\d]/g, '');

    if (!cpfLimpo || !dataNascimento) {
      setMessage('Por favor, preencha todos os campos.');
      return;
    }

    if (!isValidCPF(cpfLimpo)) {
      setMessage('CPF inválido.');
      return;
    }

    try {
      const response = await api.post('auth/login-cpf/', {
        cpf: cpfLimpo,
        data_nascimento: dataNascimento,
      });

      localStorage.setItem('access', response.data.access);
      localStorage.setItem('refresh', response.data.refresh);
      navigate('/agendamentos');
    } catch (e) {
      if (e.response?.status === 404) {
        setCadastro((prev) => ({
          ...prev,
          cpf: cpf,
          date_of_birth: dataNascimento,
        }));
        setMensagemCadastro('Complete seu cadastro para continuar.');
        setShowModal(true);
        setMessage('');
      } else {
        setMessage(e.response?.data?.error ?? 'Erro ao tentar fazer login.');
      }
    }
  };

  const handleCadastro = async (e) => {
    e.preventDefault();
    setMessage('');
    setMensagemCadastro('');
    setLoadingCadastro(true);

    const {
      first_name,
      last_name,
      email,
      cpf,
      telefone,
      date_of_birth,
      nome_social,
    } = cadastro;

    const cpfLimpo = cpf.replace(/[^\d]/g, '');
    const telefoneLimpo = telefone.replace(/[^\d]/g, '');

    // Validação geral de preenchimento
    if (
      !first_name ||
      !last_name ||
      !email ||
      !cpf ||
      !telefone ||
      !date_of_birth
    ) {
      setMessage('Por favor, preencha todos os campos.');
      setLoadingCadastro(false);
      return;
    }

    if (!isValidCPF(cpfLimpo)) {
      setMessage('CPF inválido.');
      setLoadingCadastro(false);
      return;
    }

    if (telefoneLimpo.length !== 11) {
      setMessage('Telefone inválido. Use o formato (11) 91234-5678.');
      setLoadingCadastro(false);
      return;
    }

    try {
      await api.post('auth/cadastro/', {
        first_name,
        last_name,
        email,
        cpf: cpfLimpo,
        telefone: telefoneLimpo,
        date_of_birth,
        perfil: 'paciente',
        nome_social,
      });

      const loginResponse = await api.post('auth/login-cpf/', {
        cpf: cpfLimpo,
        data_nascimento: date_of_birth,
      });

      localStorage.setItem('access', loginResponse.data.access);
      localStorage.setItem('refresh', loginResponse.data.refresh);
      navigate('/agendamentos');
    } catch (error) {
      if (error.response?.data?.email) {
        setMessage('Este e-mail já está cadastrado.');
      } else if (error.response?.data?.cpf) {
        setMessage('Este CPF já está cadastrado.');
      } else {
        setMessage('Erro ao cadastrar. Verifique os dados e tente novamente.');
      }
    } finally {
      setLoadingCadastro(false);
    }
  };

  return (
    <div className="d-flex justify-content-center align-items-center min-vh-100 bg-light p-3">
      <div
        className="card shadow-lg p-4 w-100"
        style={{ maxWidth: '450px', borderRadius: '15px' }}
      >
        <div className="card-body">
          <div className="text-center mb-4">
            <img
              src="/logo.png"
              alt="Logo"
              style={{ maxHeight: '120px' }}
              className="mb-2"
            />
            <h2 className="card-title text-primary">Agendamento digital</h2>
          </div>

          {message && (
            <div className="alert alert-danger text-center" role="alert">
              {message}
            </div>
          )}

          <form onSubmit={handleLogin}>
            <div className="mb-3">
              <label htmlFor="cpfInput" className="form-label text-secondary">
                CPF
              </label>
              <IMaskInput
                mask="000.000.000-00"
                className="form-control"
                id="cpfInput"
                required
                value={cpf}
                onAccept={(value) => setCpf(value)}
              />
            </div>

            <div className="mb-3">
              <label
                htmlFor="dataNascimentoInput"
                className="form-label text-secondary"
              >
                Data de nascimento
              </label>
              <input
                type="date"
                className="form-control"
                id="dataNascimentoInput"
                value={dataNascimento}
                onChange={(e) => setDataNascimento(e.target.value)}
                required
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary w-100 mb-3 py-2 rounded-pill"
            >
              Entrar
            </button>
          </form>

          <div className="text-center">
            <button
              className="btn btn-link text-decoration-none"
              onClick={() => setShowModal(true)}
            >
              Ainda não tem cadastro? Criar agora
            </button>
          </div>
        </div>
      </div>

      {showModal && (
        <div
          className="modal fade show d-block"
          style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <form onSubmit={handleCadastro}>
                <div className="modal-header">
                  <h5 className="modal-title">Criar conta como paciente</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setShowModal(false)}
                  ></button>
                </div>
                <div className="modal-body">
                  {message && (
                    <div
                      className="alert alert-danger text-center"
                      role="alert"
                    >
                      {message}
                    </div>
                  )}

                  {mensagemCadastro && (
                    <div className="alert alert-info text-center" role="alert">
                      {mensagemCadastro}
                    </div>
                  )}
                  <div className="mb-3">
                    <label className="form-label">Primeiro Nome</label>
                    <input
                      type="text"
                      className="form-control"
                      required
                      value={cadastro.first_name}
                      onChange={(e) =>
                        setCadastro({ ...cadastro, first_name: e.target.value })
                      }
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Sobrenome</label>
                    <input
                      type="text"
                      className="form-control"
                      required
                      value={cadastro.last_name}
                      onChange={(e) =>
                        setCadastro({ ...cadastro, last_name: e.target.value })
                      }
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Nome social (opcional)</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Se deseja ser identificado de outra forma"
                      value={cadastro.nome_social}
                      onChange={(e) =>
                        setCadastro({
                          ...cadastro,
                          nome_social: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">CPF</label>
                    <IMaskInput
                      mask="000.000.000-00"
                      className="form-control"
                      required
                      placeholder="Digite seu CPF"
                      value={cadastro.cpf}
                      onAccept={(value) =>
                        setCadastro({ ...cadastro, cpf: value })
                      }
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Telefone</label>
                    <IMaskInput
                      mask="(00) 00000-0000"
                      className="form-control"
                      placeholder="(11) 99999-9999"
                      value={cadastro.telefone}
                      onAccept={(value) =>
                        setCadastro({ ...cadastro, telefone: value })
                      }
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Data de nascimento</label>
                    <input
                      type="date"
                      className="form-control"
                      required
                      value={cadastro.date_of_birth}
                      onChange={(e) =>
                        setCadastro({
                          ...cadastro,
                          date_of_birth: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Email</label>
                    <input
                      type="email"
                      className="form-control"
                      required
                      value={cadastro.email}
                      onChange={(e) =>
                        setCadastro({ ...cadastro, email: e.target.value })
                      }
                    />
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setShowModal(false)}
                  >
                    Cancelar
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loadingCadastro}
                  >
                    {loadingCadastro ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Cadastrando...
                      </>
                    ) : (
                      'Cadastrar e entrar'
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
